module.exports = __webpack_public_path__ + "static/media/refer friend.0bae1c92.svg";